import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { HospitalServices } from "../services/HospitalServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { RpaServices } from "../services/RpaServices";
export const fetchHospitalCaseStageCount = createAsyncThunk(
  "hospital/fetchCaseStageCount",
  async (hospitalId) => {
    const res = await HospitalServices.getHospitalStageCaseCount(hospitalId);
    return res.data;
  },
);
export const fetchRpaRunningHospitals = createAsyncThunk(
  "hospital/rpaRunningHospital",
  async () => {
    const res = await RpaServices.rpaRunningHospitals();
    return res?.data?.RpaRunningHospitals;
  },
);
const HospitalSlice = createSlice({
  name: "hospital",
  initialState: {
    rpaRunningHospitals: null,
    caseStageCounts: 0,
    dialysisOnOutCount: 0,
    error: null,
    status: "idle",
  },
  reducers: {
    addRpaRunningHospitals: (state, action) => {
      state.rpaRunningHospitals = [
        ...(state.rpaRunningHospitals || []),
        action.payload,
      ];
    },
    removeRpaRunningHospitals: (state, action) => {
      state.rpaRunningHospitals =
        state.rpaRunningHospitals &&
        state.rpaRunningHospitals?.filter((id) => id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHospitalCaseStageCount.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchHospitalCaseStageCount.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.caseStageCounts =
          Number(action?.payload?.overallTotalCount?.Initiate || 0) +
          Number(action?.payload?.overallTotalCount?.Pending || 0) +
          Number(action?.payload?.overallTotalCount?.Rejected || 0);
        state.dialysisOnOutCount =
          action?.payload?.overallTotalCount?.DialysisOut || 0;
      })
      .addCase(fetchHospitalCaseStageCount.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        handleApiErrorResponses(action.error);
      })
      .addCase(fetchRpaRunningHospitals.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchRpaRunningHospitals.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.rpaRunningHospitals = state?.rpaRunningHospitals
          ? [...state.rpaRunningHospitals, ...action.payload]
          : action.payload;
      })
      .addCase(fetchRpaRunningHospitals.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        handleApiErrorResponses(action.error);
      });
  },
});
export const { addRpaRunningHospitals, removeRpaRunningHospitals } =
  HospitalSlice.actions;
export default HospitalSlice.reducer;
